import {lazy} from 'react';
import {Navigate, type RouteObject} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const PopupLayout = lazy(() => import('@/pages/mngt/popup/Popup'));
const PopupList = lazy(() => import('@/pages/mngt/popup/PopupList'));
const PopupDetail = lazy(() => import('@/pages/mngt/popup/PopupDetail'));
const PopupCreate = lazy(() => import('@/pages/mngt/popup/PopupCreate'));
const PopupEdit = lazy(() => import('@/pages/mngt/popup/PopupEdit'));

const popupRoutes: RouteObject[] = [
  {
    path: '/mngt/popup',
    element: withSuspense(<PopupLayout />),
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />
      },
      {
        path: 'list',
        element: withSuspense(<PopupList />)
      },
      {
        path: 'write',
        element: withSuspense(<PopupCreate />)
      },
      {
        path: ':id',
        element: withSuspense(<PopupDetail />)
      },
      {
        path: ':id/edit',
        element: withSuspense(<PopupEdit />)
      }
    ]
  }
];

export default popupRoutes;
